import React, { createContext, useContext, useState, useEffect } from 'react';

const TextSizeContext = createContext();

export const useTextSize = () => {
  const context = useContext(TextSizeContext);
  if (!context) {
    throw new Error('useTextSize must be used within a TextSizeProvider');
  }
  return context;
};

export const TextSizeProvider = ({ children }) => {
  const [textSize, setTextSize] = useState(() => {
    // Get saved preference from localStorage or default to 'medium'
    const saved = localStorage.getItem('textSize');
    return saved || 'medium';
  });

  useEffect(() => {
    // Save preference to localStorage whenever it changes
    localStorage.setItem('textSize', textSize);
    
    // Apply text size to document body
    document.body.className = document.body.className.replace(/text-size-\w+/g, '');
    document.body.classList.add(`text-size-${textSize}`);
  }, [textSize]);

  const value = {
    textSize,
    setTextSize
  };

  return (
    <TextSizeContext.Provider value={value}>
      {children}
    </TextSizeContext.Provider>
  );
}; 